<template>
    <div class="epf-filter-select-with-input col-12 col-md-4 col-lg-3" :class="additionalClass">
        <div class="epf-filter-select-with-input__title">{{ filterConfig.title }}</div>
        <v-select :options="availableOptions" :value="selectedOption" @input="selectOption" :components="{Deselect}" :disabled="disabled">
            <template v-slot:open-indicator>
                <div class="vs__open-indicator icon icon--arrow-down"></div>
            </template>
        </v-select>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: "EpfFilterSelectWithInput",
    components: {vSelect},
    props: {
        filterConfig: Object,
        additionalClass: ''
    },
    data: function () {
        return {
            Deselect: {
                render: createElement => createElement('span', {class: 'button button--primary button--icon icon--before icon--close'}),
            },
        }
    },
    computed: {
        disabled: function () {
            return this.availableOptions.length === 1 && this.$store.getters.filterValueByName(this.filterConfig.name) === null;
        },
        availableOptions: function () {
            return this.$store.state.availableFilterValues[this.filterConfig.name] || [];
        },
        selectedOption() {
            if (this.availableOptions.length === 1) {
                return this.availableOptions[0];
            }
            const selectedValue = this.$store.getters.filterValueByName(this.filterConfig.name);
            if (selectedValue) {
                return this.availableOptions.find((option) => {
                    let val = option.value || option;
                    if (typeof val === 'number') {
                        return val === parseInt(selectedValue);
                    }
                    return val === selectedValue;
                });
            }
            return null;
        },
    },
    methods: {
        selectOption: function (selection) {
            this.$store.dispatch('setFilterState', {
                filterName: this.filterConfig.name,
                value: selection
            });
        }
    }
}
</script>
